/** Catalog id for Forge Feedback (internal_api/forge_apps); stable if display name changes. */
export const FORGE_APP_USER_FEEDBACK_ID = 7

/** Default card thumbnail when a forge app has no icon_url / thumbnail_url from the API. */
export const FORGE_APP_DEFAULT_THUMBNAIL = require('@/assets/forge-app-placeholder.svg')

export function getForgeAppCatalogId(app) {
  if (!app) return null
  // Installed records use `id` for forge_app_setting; catalog id is forge_app_id / forge_app.id
  const id = app.forge_app_id ?? app.forge_app?.id
  return id != null ? Number(id) : null
}

export function isUserFeedbackForgeApp(app) {
  return getForgeAppCatalogId(app) === FORGE_APP_USER_FEEDBACK_ID
}
